export class TriarcData {
    static appendUrlParameter(url: string, key: string, value: string): string {
        // best guess, just check the url to see if we already have a ? for parameters
        if (url.indexOf("?") == -1) {
            url = url + "?";
        }
        key = encodeURI(key); value = encodeURI(value);
        var kvp = url.split('&');
        var i = kvp.length; var x; while (i--) {
            x = kvp[i].split('=');

            if (x[0] == key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }
        if (i < 0) { kvp[kvp.length] = [key, value].join('='); }
        //this will reload the page, it's likely better to store this until finished
        return kvp.join('&');
    }
} 